import icons from '@shared/ui/icons';
import React, { FC } from 'react';

export const NoDataSelect: FC<{
  text?: string;
  name: string;
  maxLength: number;
}> = ({ text = '', name, maxLength }) => {
  const Icon = icons.noData;
  const msg = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  return (
    <div className="flex h-full w-full flex-col items-center justify-center px-[6rem] py-[7rem]">
      <Icon
        height={60}
        width={60}
      />
      <span className="text-spanishGray mt-2 whitespace-nowrap text-center">
        There are no{' '}
        <b
          style={{ display: text ? 'block' : 'none' }}
          className={'text-chineseBlack'}
        >
          “{msg}”
        </b>{' '}
        {name} here yet. <br />
        {text && `Try searching different name.`}
      </span>
    </div>
  );
};
